module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_94-86f239c97e4789ff8c5350e395e57e68.png";